import { render, staticRenderFns } from "./Desks.vue?vue&type=template&id=37795382&scoped=true&"
import script from "./Desks.vue?vue&type=script&lang=js&"
export * from "./Desks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37795382",
  null
  
)

export default component.exports